import React from "react"
import classnames from "classnames"
import styles from "./Button.less"
import { LoadingIcon } from "AtomicComponents"
import gtmHandler from "AtomicUtils/gtmHandler"
import urlHandler from "AtomicUtils/urlHandler"
class Button extends React.PureComponent {
  _handleOnClick = () => {
    const { onClick = () => {}, external, href, disabled, gtm } = this.props
    onClick()

    // Delay for firing GTM before redirection
    // Call GTM if we have an gtm object
    if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
      gtmHandler({
        pageCategory: gtm.category,
        pageAction: gtm.action
      })
    }
    if (external && href && !disabled) {
      setTimeout(() => {
        new urlHandler(href).newTab()
      }, 200)
    } else if (href && !disabled) {
      setTimeout(() => {
        new urlHandler(href).redirect()
      }, 200)
    }
  }
  render() {
    const {
      children,
      fullWidth,
      disabled = false,
      external = false,
      label,
      href,
      styleName = "red",
      loading = false
    } = this.props

    let Tag = href && href != '' && !external ? 'a' : 'button'

    return (
      <Tag
        data-test="button"
        href={href && href != '' && !external ? href : ''}
        className={`Button ${classnames({
          [styles.Button]: true,
          [styles.ButtonRed]: styleName === "red",
          [styles.ButtonFullWidth]: fullWidth,
          [styles.ButtonWhite]: styleName === "white",
          [styles.ButtonBlack]: styleName === "black",
          [styles.ButtonBlackOutlined]: styleName === "blackOutlined",
          [styles.ButtonWhiteOutlined]: styleName === "whiteOutlined",
          [styles.ButtonWhiteOutlinedWithOpacity]:
            styleName === "whiteOutlinedWithOpacity",
          [styles.ButtonDisabled]: disabled
        })}`}
        onClick={this._handleOnClick}>
        {loading && (
          <div
            className={classnames({
              [styles.LoadingSection]: true
            })}>
            <LoadingIcon
              styleName={"dark"}
              style={{
                width: "16px",
                height: "16px"
              }}
            />
          </div>
        )}
        {children && children}
        {!children && label}
      </Tag>
    )
  }
}

export default Button



// WEBPACK FOOTER //
// ./src/AtomicComponents/Button/Button.jsx